import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function ComplexStatisticsCard({ color, title, count, percentage, icon }) {
  // Inside ComplexStatisticsCard component
  const variantConfigs = {
    royal: {
      grad: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      shadow: "rgba(118, 75, 162, 0.4)",
    },
    ocean: {
      grad: "linear-gradient(135deg, #2af5ff 0%, #2196f3 100%)",
      shadow: "rgba(33, 150, 243, 0.4)",
    },
    emerald: {
      grad: "linear-gradient(135deg, #00b09b 0%, #96c93d 100%)",
      shadow: "rgba(150, 201, 61, 0.4)",
    },
    sunset: {
      grad: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      shadow: "rgba(245, 87, 108, 0.4)",
    },
    fire: {
      grad: "linear-gradient(135deg, #f83600 0%, #f9d423 100%)",
      shadow: "rgba(248, 54, 0, 0.4)",
    },
    gold: {
      // 🆕 New gradient for the second "primary" card
      grad: "linear-gradient(135deg, #F7971E 0%, #FFD200 100%)",
      shadow: "rgba(247, 151, 30, 0.4)",
    },
  };

  const config = variantConfigs[color] || variantConfigs.royal;

  return (
    <Card
      sx={({ transitions }) => ({
        overflow: "visible",
        position: "relative",
        background: config.grad,
        borderRadius: "20px",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        boxShadow: `0 10px 20px -5px ${config.shadow}`,
        transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)", // Bouncy effect
        cursor: "pointer",
        "&:hover": {
          transform: "perspective(1000px) translateY(-15px) rotateX(8deg) rotateY(-2deg)",
          boxShadow: `0 30px 60px -12px ${config.shadow}`,
          "& .icon-wrapper": {
            transform: "translateZ(50px) translateY(-10px)",
            background: "rgba(255, 255, 255, 0.4)",
          },
        },
      })}
    >
      <MDBox display="flex" justifyContent="space-between" pt={1.5} px={2}>
        <MDBox
          className="icon-wrapper"
          sx={{
            background: "rgba(255, 255, 255, 0.25)",
            backdropFilter: "blur(8px)",
            color: "white",
            borderRadius: "15px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "3.2rem", // Chota aur clean icon box
            height: "3.2rem",
            mt: -3,
            transition: "all 0.5s ease",
            boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
            border: "1px solid rgba(255,255,255,0.3)",
          }}
        >
          <Icon fontSize="small" style={{ filter: "drop-shadow(0px 2px 2px rgba(0,0,0,0.2))" }}>
            {icon}
          </Icon>
        </MDBox>
        <MDBox textAlign="right" lineHeight={1.25}>
          <MDTypography
            variant="button"
            fontWeight="bold"
            color="white"
            sx={{ opacity: 0.85, fontSize: "0.75rem", letterSpacing: "1px" }}
          >
            {title}
          </MDTypography>
          <MDTypography variant="h3" fontWeight="bold" color="white" sx={{ mt: 0.5 }}>
            {count}
          </MDTypography>
        </MDBox>
      </MDBox>

      <Divider sx={{ mt: 2.5, mb: 1, backgroundColor: "rgba(255,255,255,0.15)" }} />

      <MDBox pb={2} px={2}>
        <MDBox display="flex" alignItems="center">
          {/* <MDBox
            sx={{
              background: "rgba(255, 255, 255, 0.2)",
              color: "white",
              padding: "3px 12px",
              borderRadius: "10px",
              fontSize: "0.75rem",
              fontWeight: "900",
              mr: 1,
              border: "1px solid rgba(255,255,255,0.2)",
              display: "inline-block",
            }}
          >
            {percentage.amount}
          </MDBox> */}
          <MDTypography variant="button" color="white" fontWeight="regular" sx={{ opacity: 0.9 }}>
            {percentage.label}
          </MDTypography>
        </MDBox>
      </MDBox>
    </Card>
  );
}

ComplexStatisticsCard.defaultProps = {
  color: "royal",
  percentage: { amount: "", label: "" },
};

ComplexStatisticsCard.propTypes = {
  color: PropTypes.oneOf(["royal", "ocean", "emerald", "sunset", "fire", "gold"]),
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  percentage: PropTypes.shape({
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
  }),
  icon: PropTypes.node.isRequired,
};

export default ComplexStatisticsCard;
